import styled from 'styled-components'
import { rgba } from 'polished'

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 70;
  background: ${(props) => rgba('#000000', 0.35)};
`

export const Panel = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 71;
  width: min(760px, 100vw);
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: -8px 0 28px rgba(0, 0, 0, 0.18);
`

export const Header = styled.header`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 20px;
  background: ${(props) => props.theme.colors.scale[500]};
  color: #fff;
`

export const HeaderText = styled.div`
  flex: 1;
  min-width: 0;

  h2 {
    font-size: 18px;
    font-weight: 700;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  p {
    margin-top: 2px;
    font-size: 12px;
    opacity: 0.9;
  }
`

export const CloseButton = styled.button`
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 8px;
  color: #fff;
  background: ${(props) => rgba('#ffffff', 0.18)};
  cursor: pointer;

  &:hover {
    background: ${(props) => rgba('#ffffff', 0.3)};
  }
`

export const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px 24px;
`

export const Aviso = styled.p`
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  background: ${(props) => rgba(props.theme.colors.scale[500], 0.1)};
  color: ${(props) => props.theme.colors.gray[700]};
`

export const Vazio = styled.p`
  padding: 32px 0;
  text-align: center;
  font-size: 13px;
  color: ${(props) => props.theme.colors.gray[500]};
`

export const Linha = styled.div`
  border: 1px solid ${(props) => props.theme.colors.gray[200]};
  border-radius: 10px;
  margin-bottom: 8px;
  overflow: hidden;
`

/* uma grade so, usada pelo cabecalho e pelas linhas, para as colunas baterem */
const grade = `
  display: grid;
  grid-template-columns:
    96px minmax(0, 0.8fr) minmax(0, 0.9fr) minmax(0, 1.7fr) 92px 104px;
  align-items: center;
  gap: 8px;

  /* numa tela estreita as oito colunas nao cabem no painel */
  @media (max-width: 820px) {
    grid-template-columns: 80px minmax(0, 1fr) minmax(0, 1fr) 92px;

    > :nth-child(4),
    > :nth-child(6) {
      display: none;
    }
  }
`

export const Cabecalho = styled.div`
  ${grade}
  padding: 6px 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  background: ${(props) => props.theme.colors.scale[500]};
  color: #fff;
`

export const ColunaBotao = styled.button`
  display: flex;
  align-items: center;
  gap: 3px;
  min-width: 0;
  padding: 2px 0;
  color: #fff;
  background: transparent;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  text-align: left;
  cursor: pointer;
  opacity: ${(props) => (props.$ativa ? 1 : 0.82)};

  &:hover {
    opacity: 1;
    text-decoration: underline;
  }

  svg {
    flex-shrink: 0;
  }
`

/*
 * div com role=button, nao <button>: dentro dela tem o atalho de abrir o
 * agendamento, e botao dentro de botao e HTML invalido — o navegador
 * desmancha a marcacao e o clique de dentro para de se comportar.
 */
export const LinhaTopo = styled.div`
  ${grade}
  width: 100%;
  padding: 10px 12px;
  text-align: left;
  background: #fff;
  cursor: default;

  &:hover {
    background: ${(props) => props.theme.colors.gray[50]};
  }
`


export const Celula = styled.span`
  font-size: 13px;
  color: ${(props) => props.theme.colors.gray[700]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  strong {
    font-weight: 600;
    color: ${(props) => props.theme.colors.gray[800]};
  }
`

export const Hora = styled(Celula)`
  font-weight: 700;
  color: ${(props) => props.theme.colors.gray[800]};
  font-variant-numeric: tabular-nums;
`

/*
 * Assinante e Status sao etiquetas de significado, nao decoracao: a cor diz o
 * que a palavra ja diz, entao nao entram na padronizacao de laranja da marca.
 */
export const Etiqueta = styled.span`
  justify-self: start;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  background: ${(props) =>
    props.$sim ? rgba('#15803d', 0.12) : props.theme.colors.gray[100]};
  color: ${(props) => (props.$sim ? '#15803d' : props.theme.colors.gray[500])};
`

/*
 * A cor vem da MESMA paleta das bolhas da grade. Status e significado, nao
 * decoracao: a etiqueta e a bolha tem de dizer a mesma coisa, senao a loja
 * precisa traduzir entre as duas.
 */
export const StatusTag = styled.span`
  justify-self: start;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  background: ${(props) => (props.$cor ? rgba(props.$cor, 0.14) : props.theme.colors.gray[100])};
  color: ${(props) => props.$cor || props.theme.colors.gray[600]};
  border: 1px solid ${(props) => (props.$cor ? rgba(props.$cor, 0.35) : 'transparent')};
`




